import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {CustomValidators} from '../../core/validator/custom-validators';
import {ValidatorService} from '../../core/validator/validator.service';
import {ProjectModel} from '../project.model';
import {HolidayModel} from '../holiday/holiday.model';
import {HolidayCategory} from '../holiday/holiday-category.enum';
import {HolidayService} from '../../core/ecv-http-services/services/holiday.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {TranslateService} from '@ngx-translate/core';
import {AlertService} from '@widgets/alert/alert.service';

@Component({
  selector: 'app-dialog-holiday',
  templateUrl: './dialog.holiday.component.html',
})
export class DialogHolidayComponent implements OnInit {
  dateForm: FormGroup;
  holidayDetailsForm: FormGroup;
  projectsModel: ProjectModel[];
  holidayDetails: HolidayModel;
  holidayCategories: number[];
  holidayCategoriesEnum: HolidayCategory[];
  @Output() holidayRequest = new EventEmitter();

  constructor(private holidayService: HolidayService,
              public activeModal: NgbActiveModal,
              private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private spinnerService: Ng4LoadingSpinnerService) {
  }

  ngOnInit() {
    this.initializeHolidayCategories();
    this.createHolidayDetailsForm();
  }

  private createHolidayDetailsForm(): void {
    this.dateForm = new FormGroup({
      'fromDate': new FormControl('', [Validators.required, CustomValidators.validateDateBeforeCurrentDay]),
      'toDate': new FormControl('', Validators.required)
    }, CustomValidators.validateDates('fromDate', 'toDate'));
    this.holidayDetailsForm = new FormGroup({
      'description': new FormControl('', {validators: CustomValidators.notEmpty, updateOn: 'blur'}),
      'project': new FormControl('', Validators.required),
      'holidayCategory': new FormControl('', Validators.required),
      'date': this.dateForm
    });
  }

  private initializeHolidayCategories() {
    this.holidayCategories = [];
    this.holidayCategoriesEnum = [];
    for (const n in HolidayCategory) {
      if (typeof HolidayCategory[n] === 'number') {
        this.holidayCategoriesEnum.push(HolidayCategory[HolidayCategory[n]]);
      }
    }
  }

  updateHolidayCategories() {
    this.holidayCategories = [];
    const project = this.projectsModel.find(value => value.id === this.holidayDetails.projectId);
    if (project) {
      project.holidayCategories.forEach(value => {
        this.holidayCategories.push(value);
      });
    }
    if (this.holidayCategories.length === 0) {
      this.holidayCategories.push(0);
    }
    this.holidayDetails.category = this.holidayCategories[0];
  }

  close() {
    this.activeModal.close(false);
  }

  save() {
    this.validatorService.validate(this.holidayDetailsForm);
    if (!this.validatorService.isValid(this.holidayDetailsForm)) {
      return;
    }
    this.spinnerService.show();
    this.holidayService.createHoliday(this.holidayDetails).subscribe(x => {
      this.translateService.get('ALERT.HOLIDAY_SAVED', {}).subscribe((res: string) => {
        this.alertService.success(res);
        this.activeModal.close(true);
      });
      this.spinnerService.hide();
    }, error => {
      this.spinnerService.hide();
    });
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/dialog/dialog.holiday.component.ts